const modules = [
  {
    key: "fundamentals",
    title: "Fondamentaux du marketing digital",
    understand:
      "Comprendre le parcours client, le positionnement et le rôle de chaque canal.",
    practice: "Relier une offre réelle à un objectif marketing précis.",
    produce: "Une base de stratégie digitale simple et exploitable.",
  },
  {
    key: "content",
    title: "Contenu, réseaux sociaux et acquisition",
    understand:
      "Comprendre comment le contenu attire, informe et prépare une décision.",
    practice:
      "Planifier des publications et adapter les formats aux canaux choisis.",
    produce: "Un mini-plan éditorial orienté vers un objectif commercial.",
  },
  {
    key: "retention",
    title: "Acquisition, fidélisation et automatisation",
    understand:
      "Comprendre les rôles complémentaires de Meta Ads, Google Ads, du SEO et de la relance.",
    practice:
      "Construire un parcours simple de l’acquisition à la fidélisation.",
    produce:
      "Un scénario prospect-client avec indicateurs et points de relance.",
  },
  {
    key: "creative",
    title: "Création graphique et motion design",
    understand:
      "Comprendre les principes visuels qui rendent un message lisible et cohérent.",
    practice: "Créer des visuels et des vidéos adaptés à une campagne.",
    produce: "Un ensemble de contenus prêts à être testés.",
  },
  {
    key: "commerce",
    title: "E-commerce, freelance et acquisition d’opportunités",
    understand:
      "Comprendre comment passer d’un produit ou d’une compétence à une offre testable.",
    practice:
      "Explorer le sourcing, la vente en ligne et la structuration d’une offre freelance.",
    produce: "Une expérimentation documentée avec critères de décision.",
  },
  {
    key: "ai",
    title: "IA appliquée au marketing",
    understand:
      "Comprendre où l’IA accélère la recherche, la création, l’analyse et l’automatisation.",
    practice:
      "Concevoir des consignes et vérifier la qualité des résultats produits.",
    produce:
      "Un workflow assisté par IA qui conserve un objectif et un contrôle humain.",
  },
];

const method = {
  title: "Apprendre en faisant, puis améliorer",
  introduction:
    "Chaque notion devient une action, un retour et une nouvelle version plus solide.",
  steps: [
    "Apprendre",
    "Appliquer",
    "Recevoir un retour",
    "Tester",
    "Mesurer",
    "Améliorer",
  ],
  delivery:
    "À Douala ou en ligne, vous suivez la même progression pratique et échangez autour de vos exercices.",
};

const laboratory = {
  title: "Le laboratoire e-commerce",
  introduction:
    "Travaillez le chemin complet d’une idée jusqu’à une décision fondée sur des observations.",
  stages: [
    "Produit",
    "Offre",
    "Contenu",
    "Acquisition",
    "Vente",
    "Analyse",
    "Optimisation",
  ],
  note: "L’objectif est d’apprendre à tester, mesurer et décider. La rentabilité d’un produit dépend du marché et de l’exécution.",
};

const bonuses = {
  title: "Des outils et des pistes pour continuer à pratiquer",
  items: [
    {
      title: "Outils premium pendant un mois",
      description:
        "Accès prévu à Canva Pro, CapCut Pro, Claude AI Max avec Higgsfield, et HeyGen AI Pro.",
    },
    {
      title: "Accompagnement vers les opportunités",
      description:
        "Repères pour l’emploi, le freelance et la construction d’une activité en ligne.",
    },
    {
      title: "Sourcing Chine",
      description:
        "Appui pour comprendre les étapes et les décisions d’une démarche de sourcing.",
    },
    {
      title: "Shopikat et KURSA",
      description:
        "Repères pour structurer une expérimentation de vente en ligne avec les solutions indiquées.",
    },
  ],
};

const proof = {
  title: "Des preuves réelles, dès qu’elles sont validées",
  introduction:
    "Cette zone accueillera uniquement des médias et retours authentiques autorisés par CSL BRANDS.",
  placeholders: [
    "[TÉMOIGNAGE À FOURNIR — profil, retour factuel et photo autorisée]",
    "[PHOTO RÉELLE À FOURNIR — session de formation au centre]",
  ],
  testimonials: [],
};

const investment = {
  title: "Un investissement lisible avant de décider",
  introduction:
    "Les frais de formation et d’inscription sont présentés séparément, puis additionnés à partir des données officielles du parcours.",
  trainingFeeLabel: "Formation",
  registrationFeeLabel: "Inscription",
  totalLabel: "Total à prévoir",
  logisticsLabel: "Durée, rentrée et mode",
  included: [
    "Les six modules",
    "La pratique accompagnée",
    "Le laboratoire e-commerce",
    "Les bonus confirmés",
  ],
  helper:
    "Choisissez votre mode : la prochaine étape ouvre WhatsApp avec votre parcours déjà renseigné.",
};

const baseFaq = [
  {
    key: "beginner",
    question: "Puis-je commencer si je suis débutant ?",
    answer:
      "Oui. Le parcours commence par les fondamentaux et avance vers des exercices concrets. Votre engagement dans la pratique reste essentiel.",
  },
  {
    key: "computer",
    question: "Dois-je avoir un ordinateur ?",
    answer:
      "Un ordinateur personnel est facultatif et des postes peuvent être disponibles au centre. Un smartphone est requis.",
  },
  {
    key: "delivery",
    question: "Quelle est la différence entre présentiel et en ligne ?",
    answer:
      "Le présentiel se déroule à Douala. Le format en ligne permet de suivre à distance avec la même progression pédagogique.",
  },
  {
    key: "booking",
    question: "Comment réserver ma place ?",
    answer:
      "Choisissez Présentiel ou En ligne, puis envoyez le message WhatsApp prérempli. L’équipe vous communiquera les modalités d’inscription.",
  },
  {
    key: "profitability",
    question: "Est-ce que la formation assure la rentabilité de mon activité ?",
    answer:
      "Non. Vous apprendrez à tester une offre, lire des indicateurs et ajuster vos décisions, mais le résultat dépend du marché et de votre exécution.",
  },
  {
    key: "after",
    question: "Que se passe-t-il après la formation ?",
    answer:
      "Vous repartez avec vos exercices, vos méthodes de travail et des pistes pour poursuivre vers l’emploi, le freelance ou un projet en ligne.",
  },
  {
    key: "documents",
    question: "Quels documents dois-je fournir ?",
    answer:
      "Une carte nationale d’identité ou un passeport est requis. L’équipe confirmera la liste complète au moment de l’inscription.",
  },
  {
    key: "language",
    question: "Puis-je suivre en français ou en anglais ?",
    answer:
      "Oui. Vous devez savoir lire et écrire en français ou en anglais. Confirmez votre langue avec l’équipe lors de l’inscription.",
  },
  {
    key: "requirements",
    question: "Quelles sont les conditions pour participer ?",
    answer:
      "Le parcours est destiné aux personnes de 22 ans minimum. Un smartphone et une pièce d’identité valide sont nécessaires.",
  },
];

const buildContent = ({
  seo,
  hero,
  audience,
  transformation,
  capabilities,
  proofContent = proof,
  specificFaq,
  finalCta,
  whatsappTemplate,
  media,
}) => ({
  seo,
  hero,
  audience,
  transformation,
  capabilities,
  modules,
  method,
  laboratory,
  bonuses,
  proof: proofContent,
  media,
  investment,
  faq: [...baseFaq, specificFaq],
  finalCta,
  whatsappTemplate,
});

export const catalogue = {
  seo: {
    title: "Formations Marketing Digital, E-commerce et IA | CSL BRANDS",
    description:
      "Comparez cinq parcours pratiques de 1 mois à 1 an, à Douala ou en ligne, et choisissez la profondeur adaptée à votre projet.",
    keywords: [
      "formation marketing digital Douala",
      "formation e-commerce Cameroun",
      "formation IA marketing",
    ],
    image: "/training/749514240_1018844154195700_8314658569172507857_n.jpg",
  },
  eyebrow: "Marketing Digital · E-commerce · IA",
  title: "Choisissez le parcours qui correspond à votre prochaine étape",
  introduction:
    "Cinq durées, un même fil conducteur : apprendre, pratiquer, mesurer et progresser sur une offre ou un projet concret.",
  offersLabel: "Les cinq parcours de formation",
  detailCta: "Voir le parcours",
  compareLabels: {
    bestFor: "Pour qui",
    approach: "Approche",
  },
  comparator: {
    eyebrow: "Comparateur",
    title: "Trouvez le parcours qui vous correspond",
    introduction:
      "Trois questions, une à la fois, pour identifier le format le plus proche de votre objectif, de votre temps disponible et de votre expérience.",
    disclaimer:
      "La correspondance s’appuie uniquement sur vos réponses. Elle ne classe pas les parcours et ne remplace pas un échange avec l’équipe.",
    stepCounter: "Étape {current} sur {total}",
    goalLabel: "Quel est votre objectif ?",
    timeLabel: "Combien de temps pouvez-vous investir ?",
    experienceLabel: "Où en êtes-vous ?",
    reasonGoal: "Objectif",
    reasonTime: "Temps",
    reasonExperience: "Expérience",
    next: "Continuer",
    seeResult: "Voir mon résultat",
    back: "Retour",
    edit: "Modifier mes réponses",
    goals: [
      {
        value: "foundations",
        label: "Poser les bases",
        description: "Clarifier les fondamentaux et passer à une première mise en pratique.",
      },
      {
        value: "practice",
        label: "Pratiquer et progresser",
        description: "Répéter, recevoir du feedback et corriger son exécution.",
      },
      {
        value: "project",
        label: "Lancer un projet e-commerce",
        description: "Relier acquisition, contenu, vente et mesure autour d’un projet.",
      },
      {
        value: "career",
        label: "Construire un portfolio",
        description: "Produire des travaux démontrables et préparer une trajectoire professionnelle.",
      },
      {
        value: "expertise",
        label: "Approfondir sur le long terme",
        description: "Développer des projets plus ambitieux et gagner en autonomie.",
      },
    ],
    times: [
      { value: "1", label: "1 mois" },
      { value: "2-3", label: "2 à 3 mois" },
      { value: "6", label: "6 mois" },
      { value: "12", label: "1 an" },
    ],
    experiences: [
      { value: "beginner", label: "Je débute" },
      { value: "practicing", label: "Je pratique déjà" },
      { value: "advanced", label: "Je veux professionnaliser" },
    ],
    pendingEyebrow: "Votre résultat",
    pendingTitle: "Votre parcours apparaîtra ici",
    pendingBody:
      "Répondez aux trois questions, une à la fois, pour voir le parcours le plus proche de vos besoins.",
    resultEyebrow: "Votre correspondance",
    whyTitle: "Pourquoi ce parcours ?",
    cta: "Voir ce parcours",
    compareCta: "Voir les cinq parcours",
    closestNote:
      "Avec le temps indiqué, voici le parcours le plus proche. Un format plus long serait nécessaire pour aller plus loin.",
    reset: "Recommencer",
    matchBadge: "Votre correspondance",
  },
  methodTitle: "Une méthode commune, plus de profondeur à chaque étape",
  methodSummary:
    "Tous les parcours relient stratégie, contenu, acquisition, création, e-commerce et IA. La durée détermine le nombre de cycles de pratique, de retour et d’amélioration.",
  offerCards: [
    {
      key: "essential",
      name: "Essentiel",
      positioning:
        "Poser des bases claires et réaliser une première mise en pratique guidée.",
      bestFor: "Débutant ou premier test",
      approach: "Fondations + première pratique",
    },
    {
      key: "progression",
      name: "Progression",
      positioning:
        "Répéter, recevoir du feedback et corriger son exécution pendant deux mois.",
      bestFor: "Personne qui veut corriger sa pratique",
      approach: "Pratique répétée + feedback",
    },
    {
      key: "immersion",
      name: "Immersion",
      positioning:
        "Relier tout le système marketing et e-commerce autour d’un projet concret.",
      bestFor: "Porteur de projet e-commerce",
      approach: "Projet complet, de l’idée à la mesure",
    },
    {
      key: "professional",
      name: "Professionnel",
      positioning:
        "Construire des travaux démontrables et préparer une trajectoire professionnelle.",
      bestFor: "Reconversion ou portfolio",
      approach: "Portfolio + trajectoire professionnelle",
    },
    {
      key: "expert",
      name: "Expert",
      positioning:
        "Approfondir ses compétences et ses projets sur un cycle d’un an.",
      bestFor: "Praticien qui veut approfondir",
      approach: "Cycle long + autonomie progressive",
    },
  ],
};

export const offers = {
  essential: buildContent({
    seo: {
      title: "Parcours Essentiel 1 mois | Marketing Digital et E-commerce",
      description:
        "Passez du flou à une méthode digitale simple en un mois avec une première mise en pratique guidée, à Douala ou en ligne.",
      keywords: [
        "formation marketing digital débutant",
        "parcours Essentiel CSL BRANDS",
        "formation digitale 1 mois",
      ],
      image:
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-5.jpeg",
    },
    hero: {
      eyebrow: "Parcours Essentiel · 1 mois",
      headline: "En 1 mois, arrêtez d’utiliser le digital au hasard.",
      support:
        "Apprenez les bases qui vous permettent de créer, publier, vendre et mesurer avec une méthode claire.",
      primaryCta: "Je réserve le parcours Essentiel",
      secondaryCta: "Voir ce que je vais apprendre",
    },
    audience: [
      "Je pars de zéro et je veux une méthode claire.",
      "Je vends déjà, mais je ne sais pas quoi publier ni comment mesurer.",
      "Je veux une première compétence directement applicable.",
      "Je veux tester le domaine avant de choisir un parcours plus long.",
    ],
    transformation: {
      title: "Du flou à une première méthode utilisable",
      before:
        "Des outils dispersés, des publications sans objectif et un processus de vente difficile à expliquer.",
      after:
        "Une offre simple, un mini-plan de contenu, une logique d’acquisition et une première expérimentation mesurable.",
    },
    capabilities: [
      "Structurer une offre simple et son objectif marketing.",
      "Créer un mini-plan de contenu orienté vente.",
      "Comprendre le rôle de Meta Ads, du SEO et de Google Ads dans l’acquisition.",
      "Mettre en place un premier parcours du prospect au client.",
      "Tester une idée e-commerce avec une logique produit, offre et mesure.",
      "Utiliser l’IA pour accélérer la recherche et la création sans perdre la stratégie.",
    ],
    specificFaq: {
      key: "one-month-depth",
      question: "Un mois suffit-il pour apprendre quelque chose d’utile ?",
      answer:
        "Le parcours est concentré sur les fondations et une première mise en pratique. Il donne un système de départ, pas la profondeur d’un cycle long.",
    },
    finalCta: {
      headline: "Commencez par un système simple que vous pouvez utiliser.",
      support:
        "Un mois pour clarifier vos bases et réaliser une première expérimentation accompagnée.",
      summary: "Essentiel · 1 mois · Douala ou en ligne",
      cta: "Je réserve le parcours Essentiel",
    },
    whatsappTemplate:
      "Bonjour CSL BRANDS, je souhaite réserver une place pour le parcours Essentiel - 1 mois, rentrée du 15 septembre 2026. Je souhaite suivre la formation en {MODE}. Merci de m’envoyer les modalités d’inscription.",
    media: {
      transformation:
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-8.jpeg",
      method:
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-9.jpeg",
      laboratory:
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-10.jpg",
      proof: [
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-11.jpg",
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-12.jpg",
      ],
    },
  }),
  progression: buildContent({
    seo: {
      title: "Parcours Progression 2 mois | Marketing Digital et E-commerce",
      description:
        "Transformez vos bases digitales en compétences répétables grâce à deux mois de pratique, de feedback et d’optimisation.",
      keywords: [
        "formation marketing digital pratique",
        "parcours Progression CSL BRANDS",
        "formation digitale 2 mois",
      ],
      image:
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-6.jpeg",
    },
    hero: {
      eyebrow: "Parcours Progression · 2 mois",
      headline: "Deux mois pour passer de « je sais » à « je sais faire ».",
      support:
        "Travaillez les six blocs du parcours, pratiquez davantage et apprenez à corriger ce qui ne produit pas le résultat attendu.",
      primaryCta: "Je réserve le parcours Progression",
      secondaryCta: "Voir ce que je vais apprendre",
    },
    audience: [
      "J’ai regardé des tutoriels, mais je manque de pratique structurée.",
      "Je publie déjà sans savoir mesurer ce qui fonctionne.",
      "Je veux relier contenu, acquisition et vente.",
      "Je veux être accompagné assez longtemps pour essayer puis corriger.",
    ],
    transformation: {
      title: "De notions isolées à une exécution répétable",
      before:
        "Des connaissances accumulées, peu de pratique et aucune boucle claire pour corriger ce qui fonctionne mal.",
      after:
        "Une stratégie cohérente, plusieurs cycles de production, des indicateurs lisibles et des corrections fondées sur le feedback.",
    },
    capabilities: [
      "Construire une stratégie digitale cohérente autour d’une offre.",
      "Planifier et produire du contenu selon un objectif d’acquisition.",
      "Pratiquer les principaux leviers publicitaires et organiques.",
      "Créer une logique simple d’acquisition, de relance et de fidélisation.",
      "Produire des visuels et des vidéos utiles à la conversion.",
      "Conduire plusieurs cycles de test, mesure et optimisation.",
      "Structurer une première offre freelance ou une expérimentation e-commerce.",
    ],
    specificFaq: {
      key: "extra-month",
      question: "Qu’apporte le deuxième mois ?",
      answer:
        "Il ajoute de la répétition, du feedback et du temps pour corriger votre travail. L’objectif est une exécution plus régulière, pas davantage de théorie.",
    },
    finalCta: {
      headline:
        "Passez de la compréhension à une pratique que vous pouvez répéter.",
      support:
        "Deux mois pour produire, mesurer, recevoir du feedback et améliorer votre exécution.",
      summary: "Progression · 2 mois · Douala ou en ligne",
      cta: "Je réserve le parcours Progression",
    },
    whatsappTemplate:
      "Bonjour CSL BRANDS, je souhaite réserver une place pour le parcours Progression - 2 mois, rentrée du 15 septembre 2026. Je souhaite suivre la formation en {MODE}. Merci de m’envoyer les modalités d’inscription.",
    media: {
      transformation:
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-9.jpeg",
      method:
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-10.jpg",
      laboratory:
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-11.jpg",
      proof: [
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-12.jpg",
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-13.jpg",
      ],
    },
  }),
  immersion: buildContent({
    seo: {
      title: "Parcours Immersion 3 mois | Marketing Digital et E-commerce",
      description:
        "Construisez, testez et optimisez un système marketing et e-commerce complet autour d’un projet concret.",
      keywords: [
        "formation e-commerce pratique",
        "parcours Immersion CSL BRANDS",
        "formation marketing digital 3 mois",
      ],
      image:
        "/training/csl-brands-formation-en-marketing-digital-e-commerce.jpeg",
    },
    hero: {
      eyebrow: "Parcours Immersion · 3 mois",
      headline:
        "Trois mois pour construire, tester et optimiser un vrai système de vente digitale.",
      support:
        "Ne restez pas au niveau des outils. Reliez stratégie, contenu, acquisition, e-commerce, analyse et IA dans une seule expérience pratique.",
      primaryCta: "Je réserve le parcours Immersion",
      secondaryCta: "Voir ce que je vais apprendre",
    },
    audience: [
      "Je veux une vraie immersion, pas une succession de cours.",
      "Je veux lancer ou tester une activité e-commerce.",
      "Je veux comprendre comment les leviers se connectent entre eux.",
      "Je veux assez de temps pour mesurer puis améliorer un projet.",
    ],
    transformation: {
      title: "D’une idée à un système relié de bout en bout",
      before:
        "Un produit ou un projet isolé, des actions marketing séparées et peu de données pour décider.",
      after:
        "Une offre testable, un système de contenu et d’acquisition, un parcours de vente et une expérimentation documentée.",
    },
    capabilities: [
      "Passer d’une idée à une offre structurée et testable.",
      "Créer un système de contenu et d’acquisition cohérent.",
      "Mettre en pratique le sourcing Chine ou Nigeria dans un cadre d’apprentissage.",
      "Construire un parcours de vente en ligne avec mesure des performances.",
      "Identifier ce qu’il faut arrêter, corriger ou amplifier à partir des données.",
      "Automatiser certaines tâches marketing avec méthode.",
      "Documenter une expérimentation e-commerce de bout en bout.",
    ],
    specificFaq: {
      key: "laboratory-project",
      question: "Dois-je déjà avoir un produit ou un projet ?",
      answer:
        "Non. Vous pouvez travailler sur un cas réel ou simulé. Le laboratoire vous aide à structurer les étapes et les critères d’une expérimentation.",
    },
    finalCta: {
      headline: "Construisez le système complet, puis apprenez à l’améliorer.",
      support:
        "Trois mois pour relier produit, offre, contenu, acquisition, vente et analyse autour d’un projet.",
      summary: "Immersion · 3 mois · Douala ou en ligne",
      cta: "Je réserve le parcours Immersion",
    },
    whatsappTemplate:
      "Bonjour CSL BRANDS, je souhaite réserver une place pour le parcours Immersion - 3 mois, rentrée du 15 septembre 2026. Je souhaite suivre la formation en {MODE}. Merci de m’envoyer les modalités d’inscription.",
    media: {
      transformation:
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-10.jpg",
      method:
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-11.jpg",
      laboratory:
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-12.jpg",
      proof: [
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-13.jpg",
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-14.jpg",
      ],
    },
  }),
  professional: buildContent({
    seo: {
      title: "Parcours Professionnel 6 mois | Marketing Digital et E-commerce",
      description:
        "Approfondissez vos compétences, produisez des travaux démontrables et préparez votre trajectoire vers l’emploi, le freelance ou l’entrepreneuriat.",
      keywords: [
        "formation marketing digital professionnelle",
        "parcours Professionnel CSL BRANDS",
        "portfolio marketing digital",
      ],
      image:
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-2.jpeg",
    },
    hero: {
      eyebrow: "Parcours Professionnel · 6 mois",
      headline:
        "Six mois pour construire une compétence que vous pouvez démontrer, pas seulement déclarer.",
      support:
        "Approfondissez les six modules, produisez des travaux démontrables et préparez votre passage vers l’emploi, le freelance ou l’entrepreneuriat.",
      primaryCta: "Je réserve le parcours Professionnel",
      secondaryCta: "Voir ce que je vais apprendre",
    },
    audience: [
      "Je prépare une reconversion et je veux construire des preuves de compétence.",
      "Je manque de projets à montrer à un employeur ou à un client.",
      "Je veux un accompagnement assez long pour progresser en profondeur.",
      "Je veux structurer une trajectoire vers l’emploi, le freelance ou l’entrepreneuriat.",
    ],
    transformation: {
      title: "D’une compétence en construction à un travail démontrable",
      before:
        "Des compétences difficiles à présenter, peu de projets documentés et une trajectoire professionnelle imprécise.",
      after:
        "Plusieurs livrables de portfolio, des choix justifiés par des indicateurs et une approche structurée des opportunités.",
    },
    capabilities: [
      "Maîtriser progressivement stratégie, contenu, acquisition, design, e-commerce et IA.",
      "Construire plusieurs livrables pouvant alimenter un portfolio.",
      "Présenter une stratégie et justifier ses choix par des objectifs et indicateurs.",
      "Structurer une offre freelance ou une approche de recherche d’emploi.",
      "Conduire des expériences e-commerce et marketing avec analyse et optimisation.",
      "Utiliser l’IA pour la production, la recherche, l’analyse et l’automatisation.",
      "Préparer la transition vers des opportunités professionnelles.",
    ],
    proofContent: {
      ...proof,
      certification: {
        labels: ["DQP", "AQP"],
        confirmationNote:
          "Détails de l’organisme émetteur, de l’équivalence et de la reconnaissance à confirmer auprès de l’équipe CSL BRANDS.",
      },
    },
    specificFaq: {
      key: "portfolio",
      question: "Quels travaux pourront alimenter mon portfolio ?",
      answer:
        "Vous construirez plusieurs livrables marketing et e-commerce. Leur forme dépendra des exercices et projets réalisés pendant le parcours.",
    },
    finalCta: {
      headline: "Construisez des compétences que votre travail peut montrer.",
      support:
        "Six mois pour approfondir, produire, documenter et préparer votre prochaine étape professionnelle.",
      summary: "Professionnel · 6 mois · Douala ou en ligne",
      cta: "Je réserve le parcours Professionnel",
    },
    whatsappTemplate:
      "Bonjour CSL BRANDS, je souhaite réserver une place pour le parcours Professionnel - 6 mois, rentrée du 15 septembre 2026. Je souhaite suivre la formation en {MODE}. Merci de m’envoyer les modalités d’inscription.",
    media: {
      transformation:
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-11.jpg",
      method:
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-12.jpg",
      laboratory:
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-13.jpg",
      proof: [
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-14.jpg",
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-15.jpg",
      ],
    },
  }),
  expert: buildContent({
    seo: {
      title: "Parcours Expert 1 an | Marketing Digital, E-commerce et IA",
      description:
        "Construisez sur un an une trajectoire approfondie fondée sur des projets, des cycles de pratique et une autonomie progressive.",
      keywords: [
        "formation marketing digital 1 an",
        "parcours Expert CSL BRANDS",
        "formation e-commerce et IA",
      ],
      image:
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-4.jpeg",
    },
    hero: {
      eyebrow: "Parcours Expert · 1 an",
      headline:
        "Un an pour passer de l’apprentissage à une vraie trajectoire professionnelle dans le digital.",
      support:
        "Approfondissez marketing, acquisition, création, e-commerce et IA avec plus de temps pour pratiquer, construire, documenter et consolider vos compétences.",
      primaryCta: "Je candidate au parcours Expert",
      secondaryCta: "Voir ce que je vais apprendre",
    },
    audience: [
      "Je vise une reconversion sérieuse et je veux comprendre ce que l’année change.",
      "Je veux plus qu’une formation courte ou une liste d’outils.",
      "Je veux construire des preuves de compétence sur la durée.",
      "Je veux relier apprentissage, projets et opportunités dans une trajectoire claire.",
    ],
    transformation: {
      title: "De l’apprentissage à une autonomie progressive",
      before:
        "Des acquis fragmentés, peu de cycles de projet et une difficulté à démontrer une progression dans la durée.",
      after:
        "Un portfolio progressif, des workflows plus avancés et une capacité renforcée à analyser, présenter et optimiser une stratégie.",
    },
    capabilities: [
      "Approfondir les six modules avec davantage de cycles de pratique et de feedback.",
      "Construire un portfolio progressif autour de projets marketing et e-commerce.",
      "Analyser, présenter et optimiser une stratégie.",
      "Structurer des expérimentations e-commerce avec plus d’autonomie.",
      "Créer des processus de contenu, acquisition, fidélisation et automatisation.",
      "Utiliser l’IA dans des workflows marketing plus avancés.",
      "Préparer une trajectoire emploi, freelance ou business avec des preuves de travail.",
    ],
    proofContent: {
      ...proof,
      certification: {
        labels: ["DQP", "AQP", "Certification internationale"],
        confirmationNote:
          "Détails de l’organisme émetteur, de l’équivalence et de la reconnaissance à confirmer auprès de l’équipe CSL BRANDS.",
      },
    },
    specificFaq: {
      key: "one-year-depth",
      question: "Que change réellement un parcours d’un an ?",
      answer:
        "La durée permet davantage de cycles de projet, de feedback, de documentation et d’autonomie progressive qu’un parcours court.",
    },
    finalCta: {
      headline:
        "Donnez à votre progression le temps de devenir une trajectoire.",
      support:
        "Un an pour approfondir les six modules, construire des projets et consolider votre autonomie.",
      summary: "Expert · 1 an · Douala ou en ligne",
      cta: "Je candidate au parcours Expert",
    },
    whatsappTemplate:
      "Bonjour CSL BRANDS, je souhaite recevoir les modalités du parcours Expert - 1 an, rentrée du 15 septembre 2026. Je souhaite suivre la formation en {MODE}. Merci de m’indiquer la procédure d’inscription et les modalités de paiement.",
    media: {
      transformation:
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-12.jpg",
      method:
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-13.jpg",
      laboratory:
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-14.jpg",
      proof: [
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-15.jpg",
        "/training/csl-brands-formation-en-marketing-digital-e-commerce-8.jpeg",
      ],
    },
  }),
};
